module.exports = __webpack_public_path__ + "img/logo-mini.399293c2.svg";